const Spinner = ({ "data-testid": dataTestId }) => (
  <div
    className="spinner-border"
    role="status"
    data-testid={dataTestId}
    style={{ width: "24px", height: "24px", color: "var(--brand-color-1)" }}
  >
    <span className="visually-hidden">Loading...</span>
  </div>
);

export default Spinner;
